import { createAction, props } from '@ngrx/store';

export const SetLoadingIndicatorStatus = createAction(
  '[LoadingIndicator] Set loading indicator status',
  props<{ isLoading: boolean }>()
);
